export default {
    quickStart: {
        pageDescription: 'Organize your videos so they’re easy to find and reuse.',
        howItWorks: 'How it works',
        eyebrow: 'A QUICK START',
        titleFirst: 'Organize your videos.',
        titleSecond: 'Find them faster.',
        descriptionFirst: 'Organize by category, date, type, or department.',
        descriptionSecond: 'Find the right footage when you need it.',
        dismiss: 'Dismiss Folders introduction',
        stepsLabel: 'How Folders works',
        createTitle: 'Create a folder',
        createDescription: 'Create a folder for an event, trade show, initiative, location, or department. Add a date when it helps.',
        addTitle: 'Bring in your videos',
        addDescription: 'Upload videos, or add footage you already have in MarketScale.',
        projectTitle: 'Group related videos',
        projectDescription: 'Use subfolders to group footage by category, date, type, or department.',
        shareTitle: 'Share or request an edit',
        shareDescription: 'Share a folder with your team, or use its videos to request an edit.',
        footnote: 'Folder links respect access permissions. Copying a link doesn’t change who can open it.',
    },
    // A
    addToFolders: 'Add to folders',
    addToFoldersText: 'Add media to folders to categorize and group your media. Use folder master cards to easily request edits for specific groups of media.',

    // C
    channelFolders: 'Channel folders',

    // E
    empty: 'Empty',

    // F
    favorites: 'Favorites',

    // G
    goToFolders: 'Go to folders',

    // I
    itemCount: 'no items | 1 item | {count} items',

    // N
    noItemsFound: 'viewing 0 videos',
    noRecentActivity: 'No recent activity',

    // R
    recentlyActive: 'Recently active',
    requestEditFromFolder: 'Request edit from folder',
    requestEditFromFolders: 'Request edit from folders',

    // S
    smartCollections: 'Smart Collections',

    // U
    updatedRelative: 'updated {relative}',
}
